// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".datepicker-base__inputs[data-v-3cc77b6a]{display:flex;gap:.5rem}.datepicker-base__legend[data-v-3cc77b6a]{font-size:.875rem}.datepicker-base__year[data-v-3cc77b6a]{width:calc(6ch + 30px)}.datepicker-base__day[data-v-3cc77b6a]{width:calc(4ch + 30px)}.datepicker-base__month[data-v-3cc77b6a]{width:-moz-max-content;width:max-content}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
